import { isFeature } from 'Cloud/Application/FeaturesEs6';

/* CLOUDWEB-17779 Редизайн попапа шаринга папок */
export const isTabFolderSharingDesign = isFeature('tabs-folder-sharing-design');

export const showWeblinkListFileSharing = isFeature('weblink-list-file-sharing');
